import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const ClickAndCollectSx = ({isSticky}:{isSticky:boolean}):SxProps => ({
    p:isSticky ? 1 : globalBreak({mobile:1,desktop:2}),
    borderRadius:0.5,
    border: '2px solid #dedede',
    '& .MuiFormControlLabel-root.Mui-disabled .MuiTypography-root':{
        color:"#ccc"
    },
    
    '& .cc-usp-text.disabled':{
        color:"#368632"
    },
    '& .cc-usp-text':{
        color:"#368632",
        fontSize: globalBreak({mobile:12, desktop: isSticky ? 14 : 16})
    },
})

export const ClickAndCollectPickUpSx:SxProps = {
    ml:globalBreak({mobile:0,desktop:0}),
    bgcolor:'#fff',
    p:globalBreak({mobile:0,desktop:2}),
    pt: globalBreak({mobile:2,desktop:2}),
    borderRadius:0.5,
    mt:1
}

export const ClickAndCollectLabelSX: SxProps = {
    width:'100%',
    '& .MuiFormControlLabel-label': {
        display: 'flex',
        alignItems: 'center',
        columnGap: 2,
        width:'100%',
        justifyContent:'space-between',
        '& .click-and-collect-label':{
            color:"#313131",
            fontWeight: 'bold',
        }
    }
}

export const StoreListSX = ({isSticky}:{isSticky:boolean}):SxProps => ({
    maxHeight: isSticky ? globalBreak({mobile:'30vh', desktop:'15em'}) : 'unset',
    overflowY: isSticky ? 'auto' : 'unset'
})